"use client";

import React from "react";
import { Droplets, Thermometer, Flame, CloudRain, Siren, Wrench, Hammer, Search, ShieldCheck, Building2, LucideIcon } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const iconMap: Record<string, LucideIcon> = {
  Droplets,
  Thermometer,
  Flame,
  CloudRain,
  Siren,
  Wrench,
  Hammer,
  Search,
  ShieldCheck,
  Building2
};
const pillars = [{
  title: "Renovation Plumbing",
  description: "Comprehensive plumbing solutions for kitchen, bathroom, and laundry renovations of all sizes.",
  icon: "Hammer"
}, {
  title: "Blocked Drains",
  description: "Advanced high-pressure water jetting and CCTV inspections to clear the most stubborn blockages.",
  icon: "Droplets"
}, {
  title: "Hot Water",
  description: "Rapid repair and installation of electric and gas hot water systems for your comfort.",
  icon: "Thermometer"
}, {
  title: "Gas Fitting",
  description: "Certified gas installations, leak detection, and maintenance for residential and commercial properties.",
  icon: "Flame"
}, {
  title: "Stormwater",
  description: "Comprehensive drainage solutions designed to handle the Central Coast's heaviest rainfall.",
  icon: "CloudRain"
}, {
  title: "Emergency",
  description: "Available 24/7 for urgent plumbing crises that require immediate professional intervention.",
  icon: "Siren"
}, {
  title: "Pipe Relining",
  description: "Modern no-dig technology to repair damaged underground pipes with minimal property disruption.",
  icon: "Wrench"
}, {
  title: "Tap & Toilet",
  description: "Expert repair and replacement of leaking taps, running toilets, and modern bathroom fixtures.",
  icon: "Hammer"
}, {
  title: "Leak Detection",
  description: "Precision acoustic and thermal imaging to locate hidden water leaks before they cause damage.",
  icon: "Search"
}, {
  title: "Backflow",
  description: "Professional testing and installation of backflow prevention devices to keep your water safe.",
  icon: "ShieldCheck"
}, {
  title: "Commercial",
  description: "Specialized plumbing maintenance and large-scale fit-outs for Central Coast businesses.",
  icon: "Building2"
}];
export default function CommunityPillars() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="23694" id="our-plumbing-expertise" className="bg-muted py-24 relative overflow-hidden text-foreground">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="text-center mb-16 space-y-4">
          <span className="text-accent-foreground font-mono font-bold tracking-widest uppercase text-sm md:text-base">
            Professional Solutions
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-primary font-sans tracking-tight">
            Our Plumbing Expertise
          </h2>
        </div>

        <div ref={ref} className={cn("grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {pillars.map((pillar, i) => {
          const IconComponent = iconMap[pillar.icon];
          return <div key={i} data-index={i} className="group h-full">
                <Card className="h-full bg-white border-none rounded-[24px] shadow-sm transition-all duration-500 ease-out hover:-translate-y-2 hover:shadow-xl p-10 flex flex-col items-center text-center">
                  <div className="mb-6 p-4 rounded-2xl bg-primary/5 text-primary transition-all duration-300 group-hover:bg-primary/10 group-hover:text-blue-500">
                    {IconComponent && <IconComponent className="w-10 h-10" strokeWidth={1.5} />}
                  </div>
                  <h3 className="text-xl font-bold text-primary mb-3 font-sans">
                    {pillar.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed font-sans text-sm">
                    {pillar.description}
                  </p>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}